const defaultFilters = {
  programYears: [],
  projectTypes: [],
  programNames: [],
};

export default defaultFilters;
